import type { ExtractPropTypes } from "vue";
import type { LayoutProps } from "../../index";

export const ModulePropsOption = {
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
